import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { SendOnBehalfPermissionsPage } from '../../containers/SendOnBehalfPermissionsPage';

export const AdminAccountSendOnBehalfPermissionsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<SendOnBehalfPermissionsPage />
		</AdminDashboardPageLayout>
	);
};
